export interface HandoffFact {fieldId:string;label:string;value:string}
export interface HandoffBrief {
 reference:string;
 transaction:'buyer'|'seller';
 contact:{name:string;phone:string;email:string};
 zip:string;price:number;language:string;
 facts:HandoffFact[];
 permission:{method:'operator_attested';purpose:'buyer'|'seller';recordedAt:string};
}
export interface ScriptHandoff extends HandoffBrief {
 version:1;scriptSessionId:string;scriptRevision:number;scriptType:'buyer'|'seller';
 scriptVersion?:string;caseId?:string;
 callId:string|null;sourcePersonId:number|null;operatorId:string;
}
// Explicit projection: source account/contact IDs and raw script answers stay internal.
export function agentHandoff(h:ScriptHandoff):HandoffBrief {
 return {reference:h.reference,transaction:h.transaction,contact:h.contact,zip:h.zip,price:h.price,language:h.language,facts:h.facts,permission:h.permission};
}
export function handoffText(h:HandoffBrief):string {
 return [
  `WINGS COMMAND — ${h.transaction.toUpperCase()} INTRODUCTION`,
  `Handoff reference: ${h.reference}`,
  `Caller: ${h.contact.name||'Not recorded'}`,
  `Phone: ${h.contact.phone||'Not recorded'}`,
  `Email: ${h.contact.email||'Not recorded'}`,
  `ZIP for this ${h.transaction==='buyer'?'purchase':'sale'}: ${h.zip}`,
  `${h.transaction==='buyer'?'Purchase price ceiling':'Expected selling price'} (USD): ${h.price}`,
  `Language: ${h.language}`,
  ...h.facts.map(f=>`${f.label}: ${f.value||'Unknown / not recorded'}`),
  `Caller agreed to a live ${h.permission.purpose}-agent introduction. Recorded by the operator at ${h.permission.recordedAt}.`,
  'Details read back by the operator; not independently verified against a transcript. Financing is self-reported.',
  'Agent acceptance, caller connection, and appointment attendance are separate outcomes.'
 ].join('\n');
}
